import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'modal',
    initialState: {
        openedModals: [],
        modalData: {},
    },
    reducers: {
        open_modal: (state, action) => {
            const { name, data } = action.payload;
            const isAlreadyOpen = state.openedModals.includes(name);

            return {
                ...state,
                openedModals: isAlreadyOpen ? state.openedModals : [...state.openedModals, name],
                modalData: {
                    ...state.modalData,
                    [name]: { ...(data || {}) },
                },
            };
        },
        close_modal: (state, action) => {
            return {
                ...state,
                openedModals: state.openedModals.filter((modals) => modals !== action.payload),
                modalData: {
                    ...state.modalData,
                    [action.payload]: undefined,
                },
            };
        },
        close_all_modal: (state) => {
            return {
                ...state,
                openedModals: [],
                modalData: {},
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
